export interface Category {
  id: string;
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'zhongzhi-jishu',
    name: '种植技术',
    icon: 'ri-plant-line',
    description: '从播种到收获的全流程黄瓜种植技术指南，包括土壤管理、水肥调控、温湿度控制等关键技术要点。',
    articleCount: 28,
  },
  {
    id: 'cat-2',
    slug: 'pinzhong-daiquan',
    name: '品种大全',
    icon: 'ri-seedling-line',
    description: '涵盖国内外优质黄瓜品种详细介绍，包括华北型、华南型、欧洲温室型等各类品种特性与栽培要点。',
    articleCount: 35,
  },
  {
    id: 'cat-3',
    slug: 'bingchonghai-fangzhi',
    name: '病虫害防治',
    icon: 'ri-shield-check-line',
    description: '黄瓜常见病虫害识别图谱、综合防治方案与绿色防控技术，帮助种植户科学应对各类病害威胁。',
    articleCount: 22,
  },
  {
    id: 'cat-4',
    slug: 'shichang-hangqing',
    name: '市场行情',
    icon: 'ri-line-chart-line',
    description: '全国主要批发市场黄瓜价格实时行情、供需分析与价格走势预测，助力经销商把握市场脉搏。',
    articleCount: 45,
  },
  {
    id: 'cat-5',
    slug: 'zhongzi-xuangou',
    name: '种子选购',
    icon: 'ri-shopping-bag-3-line',
    description: '黄瓜种子选购指南、品牌评测与购买渠道推荐，帮助种植户选对种子、种好黄瓜。',
    articleCount: 18,
  },
  {
    id: 'cat-6',
    slug: 'jiagong-chucun',
    name: '加工储存',
    icon: 'ri-fridge-line',
    description: '黄瓜采后处理、保鲜储存、深加工技术全解析，延长货架期、提升产品附加值。',
    articleCount: 15,
  },
];